import AsyncComponent from "components/AsyncComponent";

export const FacebookPage:any = AsyncComponent(callback => {
  require.ensure([], (require) => {
        const FBTabPageRoute = require("../components/FBTabPage").FBTabPageRoute;
        callback(FBTabPageRoute)
    },"fbTabpage");
});


// WEBPACK FOOTER //
// ./src/Apps/ticketing/routes/facebook.ts